module.exports = __webpack_public_path__ + "img/commerce2.167a29c7.png";